import { useEffect, useMemo, useState } from 'react';

import { parseCookies } from 'src/modules/safe-cookies';
import { useSelector } from 'src/store/react';
import { selectFeatureFlag } from 'src/store/selectors';

const MOCK_COMPETITIVE_JOBS = [
  {
    company: {
      name: 'Creative Solutions Pty Ltd',
    },
    title: 'Junior Developer',
    id: '104',
    location: 'Perth, WA',
    postedDateFormatted: '5 hours ago',
  },
  {
    company: {
      name: 'Global Tech Enterprises',
    },
    title: 'Lead Data Engineer',
    id: '105',
    location: 'Adelaide, South Australia',
    postedDateFormatted: '2 days ago',
    branding: {
      assets: {
        logo: {
          id: 'abc123',
          url: 'https://image-service-cdn.seek.com.au/6dc52b4f1a32ebcc38ba9a8cc0cd2b2ee3307c11/dffceafa8da80ae865f1fa835a87a74a26be6546',
          strategies: {
            jdpLogo:
              'https://image-service-cdn.seek.com.au/f080aeacc93840c49ebeb45883f0e91660f844ad/jdpLogo',
          },
        },
      },
    },
  },
  {
    company: {
      name: 'Innovative Financial Services Group',
    },
    title: 'Chief Financial Officer (CFO)',
    id: '106',
    location: 'Hobart, Tasmania, Australia',
    postedDateFormatted: '1 week ago',
  },
];

export const useMockCompetitiveJobs = (jobId: number) => {
  const enableCompetitivePlacement = useSelector(
    selectFeatureFlag('competitivePlacement'),
  );

  const cookies = useMemo(() => parseCookies(), []);

  const [isReturnMock, setIsReturnMock] = useState(false);

  // To avoid SSR mismatch, since we don't have access to cookies on the server
  useEffect(() => {
    setIsReturnMock(
      enableCompetitivePlacement && cookies.COMPETITIVE_PLACEMENT === 'MOCK',
    );
  }, [cookies.COMPETITIVE_PLACEMENT, enableCompetitivePlacement]);

  return useMemo(
    () =>
      isReturnMock
        ? // When ID end with 0, 1, 2, 3, show 0, 1, 2, 3 competitive jobs respectively
          // Otherwise, use the last digit to determine how many competitive jobs to show by using the remainder of 4
          MOCK_COMPETITIVE_JOBS.splice(0, (Number(jobId) % 10) % 4)
        : [],
    [isReturnMock, jobId],
  );
};
